import { render, staticRenderFns } from "./BuscarBase.vue?vue&type=template&id=2a0aa952"
import script from "./BuscarBase.vue?vue&type=script&setup=true&lang=js"
export * from "./BuscarBase.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports